<template>
  <div :id="$attrs['id']" :class="[$attrs['class']]" class="btn--more__content__item" @click="$emit('click', $event)">
    <slot />
  </div>
</template>

<script>


export default {
  name: 'ButtonMoreItem',

  mixins: [],

  props: {
  },

  computed: {

  },

  methods: {

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
   @import '~styles/import';
</style>



// WEBPACK FOOTER //
// src/components/lib/buttons/ButtonMoreItem.vue